// extracted by mini-css-extract-plugin
export default {"list":"OnboardingUL--list--HeS3U"};